<template>
  <div class="m-5">
    <d-table class="" :data="notifications" :loading="loadingNotifications" paginated backend-pagination striped detail-key="id" :total="total" backend-sorting :default-sort="[pagination.sortField, pagination.sortOrder]" default-sort-direction="desc" :per-page="pagination.pageSize" @page-change="page => pagination.page = page" @sort="onSort">
      <template #action-buttons>
        <div class="text-primary-500  h2 ">
          My Notifications
        </div>
      </template>
      <template #action-buttons-right>
        <d-btn @click="markAllAsRead()">
          Mark All As Read
        </d-btn>
      </template>
      <template slot-scope="props">
        <d-table-column field="createdAt" :row="props.row" label="Date" sortable>
          <span v-if="!props.row.read">
            <b>{{ props.row.createdAt | formatShortDateTime }}</b>
          </span>
          <span v-else>{{ props.row.createdAt | formatShortDateTime }}</span>
        </d-table-column>
        <d-table-column field="read" :row="props.row" label="Read" sortable>
          <d-icon v-if="!props.row.read" icon="envelope" @click.native="launchReadNotificationModal(props.row)" />
          <d-icon v-else icon="envelope-open" @click.native="launchReadNotificationModal(props.row)" />
        </d-table-column>
        <d-table-column field="fromName" :row="props.row" label="From" sortable>
          <span v-if="!props.row.read">
            <b>{{ props.row.fromName }}</b>
          </span>
          <span v-else>{{ props.row.fromName }}</span>
        </d-table-column>
        <d-table-column field="subject" :row="props.row" label="Subject" sortable>
          <span v-if="!props.row.read">
            <b>{{ props.row.subject }}</b>
          </span>
          <span v-else>{{ props.row.subject }}</span>
        </d-table-column>
      </template>
    </d-table>
  </div>
</template>

<script>
  import axios from 'axios';
  import NotificationContentModal from '@resources/scripts/patterns/NotificationContentModal.vue';

  export default {
    parent: true,

    data: () => ({
      notifications: [],
      loadingNotifications: false,
      total: 0,
      filter: '',
      pagination: {
        page: 1,
        pageSize: 20,
        sortField: 'createdAt',
        sortOrder: 'desc',
      },
    }),
    watch: {
      pagination: {
        handler() {
          this.getUserNotifications();
        },
        deep: true,
      },
      filter() {
        this.getUserNotifications();
      },
    },
    mounted() {
      this.getUserNotifications();
    },

    methods: {
      async getUserNotifications() {
        const {
          page, sortField, sortOrder, pageSize,
        } = this.pagination;
        const params = [`filter=${this.filter}`, `sortDir=${sortField} ${sortOrder}`, `currentPage=${page}`, `pageSize=${pageSize}`].join('&');
        this.loadingNotifications = true;
        const { data } = await axios.get(`/api/user/notifications/paged?${params}`);
        this.notifications = data.resultItems;
        this.total = data.totalRecords;
        this.loadingNotifications = false;
      },

      async launchReadNotificationModal(notification) {
        await axios.patch(`/api/user/notifications/${notification.id}`);

        this.$modal.open({
          parent: this,
          component: NotificationContentModal,
          hasModalCard: true,
          width: 800,
          events: {
            getUserNotifications: () => this.getUserNotifications(),
          },
          props: {
            notification,
          },
        });
      },
      onSort(field, order) {
        this.pagination.sortField = field;
        this.pagination.sortOrder = order;
      },
      async markAllAsRead() {
        this.loadingNotifications = true;
        await axios.patch('/api/user/notifications/mark-all-read');
        this.getUserNotifications();
      },
    },
  };
</script>